import { Subject } from "rxjs";

const MessageSuggestionSubject = new Subject();

const MessageSuggestionService = {
  listen: () => MessageSuggestionSubject.asObservable(),
  suggestMessagesFor: (message) => {
    if (message.suggestions && message.suggestions.length) {
      MessageSuggestionSubject.next(message);
    }
  },
  resetSuggestion: () => {
    MessageSuggestionSubject.next(null);
  }
};

export default MessageSuggestionService;
